<template>
  <a-modal
    v-model="dialogVisible"
    title="保函审核记录"
    :mask-closable="false"
    width="800px"
    @ok="closeDialog"
    @cancel="closeDialog"
  >
    <jczh-table-content
      :data="list"
      :option="listOption"
      pagination
      :page.sync="page"
      :limit.sync="size"
      :total="total"
      @pagination="getAuditHistory"
    >
      <template v-slot:letterFile="{ row }">
        <upload
          :props-data="{
            disabled: true,
            uploadMode: 'fileId',
            fileIdBefore: row.gfLetterFileIds[0]
          }"
        />
      </template>
    </jczh-table-content>
  </a-modal>
</template>

<script>
// 组件
import Upload from '@/components/common/Upload'
// 接口
import { getAuditOfflineLetterHistoryApi } from '@/api/procure/invite-bid'
import { guaranteeLetterOfflineStatusDict } from '@/dictionary/project/common'
/**
 * @description 投标电子保函审核记录弹窗
 */
export default {
  name: 'GuaranteeLetterAuditHistory',

  components: { Upload },

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    orderId: {
      type: [Number, String],
      default: ''
    },

    tradeId: {
      type: [Number, String],
      default: ''
    }
  },

  data() {
    return {
      list: [],
      page: 1,
      size: 10,
      total: 0,
      listOption: [
        { label: '操作时间', prop: 'gfLetterApprovalTime' },
        {
          label: '保函文件',
          prop: 'gfLetterFileId',
          slotName: 'letterFile',
          minWidth: '120px'
        },
        {
          label: '审核结果',
          prop: 'approvalStatus',
          filter: value =>
            guaranteeLetterOfflineStatusDict.translate(value)?.label || '-'
        },
        { label: '审核意见', prop: 'gfLetterApprovalOp' },
        { label: '审核人', prop: 'approvalName' }
      ]
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  watch: {
    visible(val) {
      if (val) this.getAuditHistory()
    }
  },

  methods: {
    /**
     * 查询审核记录
     */
    getAuditHistory() {
      const params = {
        page: this.page,
        size: this.size
      }
      getAuditOfflineLetterHistoryApi(this.orderId, this.tradeId, params)
        .then(res => {
          this.list = (res.data?.records || []).map(item => {
            return {
              gfLetterFileId:
                item.gfLetterFileId?.length > 0 ? item.gfLetterFileIds[0] : '',
              ...item
            }
          })
          this.total = res.data?.total || 0
        })
        .catch(err => {
          console.error('查询线下保函审核记录失败', err)
          if (err?.message) this.$message.error(err.message)
        })
    },

    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped></style>
